export const getAvailableOptions = (allOptions, selectedOptions) => {
  return allOptions?.filter((option) => !selectedOptions?.some((selected) => selected.value === option.value));
};
